/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import * as actionTypes from './actionTypes';
import moment from 'moment';
export const initialState = {
  planType: [],
  getAllTemplateType: [],
  quarter: '',
  getGCLData: [],
  gclDetailPageData: [],
  gclDetailPageList: [],
  saveGclData: [],
  sendGclData: [],
  extraState: {
    fullScreen: false,
    saveAction: false,
    actionType: '',
  },
  selection_list: '',
  getPriorQtrData: null,
  toMailId: [],
  fromMailId: [],
  pdfPreview: '',
};
const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_GCL_EXTRA_STATE:
      return { ...state, extraState: action.extraState };
    case actionTypes.GET_PLAN_TYPE_DATA_GCL:
      return { ...state, planType: action.payload };
    case actionTypes.SELECTION_TYPE_OPTIONS:
      return { ...state, selection_list: action.payload };
    case actionTypes.ERROR_MESSAGES_GCL:
      return { ...state, getErrorsFromGCL: action.payload };
    case actionTypes.GET_ALL_TEMPLATE_TYPE:
      return { ...state, TemplateType: action.TemplateType };
    case actionTypes.GET_QUARTER_VALUE_GCL:
      return { ...state, quarter: action.payload };
    case actionTypes.GET_GCL_DATA:
      return { ...state, getGCLData: action.payload };
    case actionTypes.GET_GCL_DETAIL_PAGE_DATA:
      return { ...state, gclDetailPageData: action.payload };
    case actionTypes.GET_GCL_DETAIL_PAGE_DATA_LIST:
      return { ...state, gclDetailPageList: action.gclDetailPageList };
    case actionTypes.SAVE_GCL_DATA:
      return { ...state, saveGclData: action.payload };
    case actionTypes.SEND_GCL_DATA:
      return { ...state, sendGclData: action.payload };
    case actionTypes.GET_GCL_PDF_DATA:
      return { ...state, pdfPreview: action.pdfPreview };
    case actionTypes.FLAG_NAVIGATION:
      return { ...state, statusBit: action.payload };
    case actionTypes.GET_PRIOR_QTR_DATA:
      return { ...state, getPriorQtrData: action.payload };
    case actionTypes.GET_TO_MAIL_ID_GCL:
      return { ...state, toMailId: action.toMailId };
    case actionTypes.GET_FROM_MAIL_ID_COLLECTION_LETTER:
      return { ...state, fromMailId: action.payload };
    case actionTypes.GENERATE_COLLECTION_LETTER_CLEAR_REDUX_DATA:
      return action.payload ? action.payload : { ...initialState };
    default:
      return state;
  }
};
export default reducer;
